module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-body eventos"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31506516","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/eventos/Main.vue
// module id = 1604
// module chunks = 17